import { CalendarMonth, ViewAgenda } from '@mui/icons-material';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { setCalendarMode } from '../../reducers/CalendarReducer';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';

export default function ToggleCalendarAgenda() {
  const { t } = useTranslation(namespace);
  const dispatch = useAppDispatch();
  const calendarMode = useAppSelector((state) => state.CalendarReducer.calendarMode);

  const handleViewChange = (
    event: React.MouseEvent<HTMLElement>, 
    newView: 'calendar' | 'agenda' | null
  ) => {
    if (newView !== null) {
      dispatch(setCalendarMode(newView));
    }
  };

  return (
    <ToggleButtonGroup
        value={calendarMode}
        exclusive
        onChange={handleViewChange}
        aria-label="view mode"
        sx={{
          gap: '4px',
          border: 'none',
          minWidth: '240px',
          '& .MuiToggleButton-root': {
            flex: 1,
            border: 'none',
            borderRadius: '4px',
            padding: '4px 8px',
            textTransform: 'none',
            color: 'var(--color-text)',
            fontSize: '14px',
            fontWeight: 600,
            '&:hover, &:active, &:focus, &.Mui-selected': {
              backgroundColor: 'var(--color-surface-muted)',
            },
            '&.Mui-selected:hover': {
              backgroundColor: 'var(--color-surface-muted)',
            },
            '& .MuiSvgIcon-root': {
              fontSize: '16px',
              marginRight: '8px',
              color: 'inherit',
              position: 'relative',
              top: '-1px',
            },
          },
        }}
      >
        <ToggleButton value="calendar" aria-label="calendar view">
          <CalendarMonth /> {t('calendar.calendar', 'Calendar')}
        </ToggleButton>
        <ToggleButton value="agenda" aria-label="agenda view">
          <ViewAgenda /> {t('calendar.agenda', 'Agenda')}
        </ToggleButton>
      </ToggleButtonGroup>
  );
} 